import { extend } from 'vee-validate';

extend('phone_number', {
  validate: (value) => {
    if (value) {
      // https://github.com/sakatam/a-better-jp-phone-regex
      return /^(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})$/.test(
        value
      );
    } else {
      return true;
    }
  },
});
